"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsError = void 0;
class IsError extends Error {
    statusCode;
    name;
    isInvoiceSimpleError = true;
    logToRollbar;
    userMessage;
    originalError;
    logData;
    reasonCode;
    constructor(statusCode, name, message, reasonCode, userMessage, originalError, args) {
        super(message);
        this.statusCode = statusCode;
        this.name = name;
        this.isInvoiceSimpleError = true;
        this.originalError = originalError;
        this.reasonCode = reasonCode;
        this.userMessage = userMessage;
        this.logData = args?.logData;
        this.logToRollbar = args?.logToRollbar ?? 'ERROR';
        if (originalError) {
            this.stack = originalError.stack;
        }
    }
    toString() {
        return JSON.stringify(this);
    }
}
exports.IsError = IsError;
